import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import './styles/global.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Auth />} />
					<Route path="/auth" element={<Auth />} />
          <Route path="/home" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
